export default __webpack_public_path__ + "static/media/mask2.79ca32c3.svg";